import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from '../../../../../../packages/utx-access-client/src/react';

export interface LockCardModalProps {
  onLayout: (event: any) => void;
}

export enum LockCardStackRoutes {
  Confirm = 'confirm',
  Placed = 'placed'
}

export type LockCardStackParamList = {
  [LockCardStackRoutes.Confirm]: LockCardModalProps & {
    account: string;
    tab?: number;
    onType: (value: string | undefined) => void;
    record?: Card;
    func?: (cardId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    actionResponse?: any;
    actionError?: any;
    onData?: (data: any) => void;
    refresh?: () => void;
  };
  [LockCardStackRoutes.Placed]: LockCardModalProps & {
    account: string;
    tab?: number;
    type: string | undefined;
    record?: Card;
    data?: any;
    refresh?: () => void;
  };
};

export type LockCardStackScreenProps<Screen extends keyof LockCardStackParamList> = NativeStackScreenProps<LockCardStackParamList, Screen>;
